import { ProviderName } from '../../../../Quotes/types/store';

export const cloudProviderForDisplay = (provider: ProviderName) => {
  if (provider === ProviderName.AWS) {
    return 'Amazon Web Services';
  }

  return 'Microsoft Azure';
};
